"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const FloatingComponent = ({ children, lockScroll = true, customContentHeight, customClass = '', customPortalElement, usePortal = true }) => {
    const ref = (0, react_1.useRef)(null);
    const childRef = (0, react_1.useRef)(null);
    const mainbody = document.querySelector('.main-body');
    const styledScrollbar = document.querySelectorAll('#styled-scrollbar');
    const [clientRect, setClientRect] = (0, react_1.useState)(null);
    const [top, setTop] = (0, react_1.useState)(null);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [horizontalAlign, setHorizontalAlign] = (0, react_1.useState)(null);
    const [verticalAlign, setVerticalAlign] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (lockScroll) {
            mainbody?.style.setProperty('overflow', 'hidden', 'important');
            for (let i = 0; i < styledScrollbar.length; i++) {
                styledScrollbar[i].style.setProperty('overflow', 'hidden', 'important');
            }
            return () => {
                if (mainbody)
                    mainbody.style.overflow = '';
                for (let i = 0; i < styledScrollbar.length; i++) {
                    styledScrollbar[i].style.overflow = '';
                }
            };
        }
        // eslint-disable-next-line
    }, []);
    const calculatePosition = (0, react_1.useCallback)(() => {
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const height = customContentHeight ||
            childRef?.current?.firstElementChild?.getBoundingClientRect().height ||
            0;
        const width = childRef?.current?.firstElementChild?.getBoundingClientRect().width || 0;
        const rect = ref?.current?.getBoundingClientRect();
        setClientRect(rect || null);
        if (!rect)
            return;
        if (vw < rect?.left + width) {
            setHorizontalAlign('right');
        }
        if (vh < rect?.top + rect?.height + height) {
            setVerticalAlign('top');
        }
        else {
            setVerticalAlign('bottom');
        }
        setTop(rect?.top);
        setVisible(true);
    }, [childRef, customContentHeight]);
    (0, react_1.useEffect)(() => {
        if (ref && childRef) {
            calculatePosition();
        }
    }, [ref, childRef, calculatePosition]);
    return (react_1.default.createElement("div", { ref: ref, className: "absolute w-full h-full top-0 left-0 is-portal pointer-events-none" }, usePortal ? (react_1.default.createElement(FloatingPortal, { customClass: customClass, customPortalElement: customPortalElement, cssStyle: {
            position: 'fixed',
            left: clientRect?.left,
            zIndex: 1002,
            visibility: visible ? 'visible' : 'hidden',
            width: clientRect?.width,
            height: clientRect?.height,
            pointerEvents: 'none',
            ...(top && { top: top })
        } },
        react_1.default.createElement("div", { className: "pointer-events-auto", ref: childRef }, react_1.default.cloneElement(children, {
            ...(horizontalAlign && {
                position: horizontalAlign
            }),
            ...(verticalAlign && { vPosition: verticalAlign })
        })))) : (react_1.default.createElement("div", { className: "pointer-events-auto", ref: childRef }, react_1.default.cloneElement(children, {
        ...(horizontalAlign && {
            position: horizontalAlign
        }),
        ...(verticalAlign && { vPosition: verticalAlign })
    })))));
};
const FloatingPortal = ({ children, customClass, cssStyle, customPortalElement }) => {
    const sharedDropdown = customPortalElement || document.getElementById(`shared-dropdown`);
    return (sharedDropdown &&
        react_dom_1.default.createPortal(react_1.default.createElement("div", { id: 'floating-dropdown', className: customClass, style: cssStyle, onClick: (e) => {
                e.stopPropagation();
            } }, children), sharedDropdown));
};
exports.default = FloatingComponent;
